import React from 'react'
import { useTranslation } from 'react-i18next'
import { Button, DialogOverlayActions, DialogOverlayFooter } from '@fs/zion-ui'

/**
 * Shared footer component for dialog overlays with pick another highlight and review actions
 */
const SharedDialogFooter = ({ onCancel, onReview }) => {
  const [t] = useTranslation()

  return (
    <DialogOverlayFooter>
      <DialogOverlayActions>
        <Button data-testid="pick-another-highlight" onClick={onCancel}>
          {t('edit-hightlight.used-by-other-field.pick-another-highlight', 'Pick another highlight')}
        </Button>
        <Button data-testid="review-shared-highlight" onClick={onReview} emphasis="high">
          {t('edit-hightlight.used-by-other-field.review', 'Review')}
        </Button>
      </DialogOverlayActions>
    </DialogOverlayFooter>
  )
}

export default SharedDialogFooter
